/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var extproto_ext_pb = require('../../../../../../../../../../extproto/ext_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/extensions/transformation_ee/transformation_pb.js');
goog.exportSymbol('proto.envoy.config.filter.http.modsecurity.v2.AuditLogging', null, global);
goog.exportSymbol('proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogAction', null, global);
goog.exportSymbol('proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogLocation', null, global);
goog.exportSymbol('proto.envoy.config.filter.http.modsecurity.v2.ModSecurity', null, global);
goog.exportSymbol('proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute', null, global);
goog.exportSymbol('proto.envoy.config.filter.http.modsecurity.v2.RuleSet', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.envoy.config.filter.http.modsecurity.v2.AuditLogging, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.displayName = 'proto.envoy.config.filter.http.modsecurity.v2.AuditLogging';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    location: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.config.filter.http.modsecurity.v2.AuditLogging;
  return proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 2:
      var value = /** @type {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogLocation} */ (reader.readEnum());
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLocation();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogAction = {
  NEVER: 0,
  RELEVANT_ONLY: 1,
  ALWAYS: 2
};

/**
 * @enum {number}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogLocation = {
  FILTER_STATE: 0,
  DYNAMIC_METADATA: 1
};

/**
 * optional AuditLogAction action = 1;
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogAction}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.prototype.getAction = function() {
  return /** @type {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogAction} value */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional AuditLogLocation location = 2;
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogLocation}
 */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.prototype.getLocation = function() {
  return /** @type {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogLocation} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.AuditLogLocation} value */
proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.prototype.setLocation = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.repeatedFields_, null);
};
goog.inherits(proto.envoy.config.filter.http.modsecurity.v2.ModSecurity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.displayName = 'proto.envoy.config.filter.http.modsecurity.v2.ModSecurity';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.toObject = function(includeInstance, msg) {
  var f, obj = {
    disabled: jspb.Message.getFieldWithDefault(msg, 1, false),
    ruleSetsList: jspb.Message.toObjectList(msg.getRuleSetsList(),
    proto.envoy.config.filter.http.modsecurity.v2.RuleSet.toObject, includeInstance),
    customInterventionMessage: jspb.Message.getFieldWithDefault(msg, 3, ""),
    auditLogging: (f = msg.getAuditLogging()) && proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.toObject(includeInstance, f),
    requestHeadersOnly: jspb.Message.getFieldWithDefault(msg, 6, false),
    responseHeadersOnly: jspb.Message.getFieldWithDefault(msg, 7, false),
    regressionLogs: jspb.Message.getFieldWithDefault(msg, 4, false),
    dlpTransformation: (f = msg.getDlpTransformation()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurity}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.config.filter.http.modsecurity.v2.ModSecurity;
  return proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurity}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 2:
      var value = new proto.envoy.config.filter.http.modsecurity.v2.RuleSet;
      reader.readMessage(value,proto.envoy.config.filter.http.modsecurity.v2.RuleSet.deserializeBinaryFromReader);
      msg.addRuleSets(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomInterventionMessage(value);
      break;
    case 5:
      var value = new proto.envoy.config.filter.http.modsecurity.v2.AuditLogging;
      reader.readMessage(value,proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.deserializeBinaryFromReader);
      msg.setAuditLogging(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestHeadersOnly(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResponseHeadersOnly(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRegressionLogs(value);
      break;
    case 8:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation.deserializeBinaryFromReader);
      msg.setDlpTransformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getRuleSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.envoy.config.filter.http.modsecurity.v2.RuleSet.serializeBinaryToWriter
    );
  }
  f = message.getCustomInterventionMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAuditLogging();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.serializeBinaryToWriter
    );
  }
  f = message.getRequestHeadersOnly();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getResponseHeadersOnly();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getRegressionLogs();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getDlpTransformation();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool disabled = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setDisabled = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated RuleSet rule_sets = 2;
 * @return {!Array<!proto.envoy.config.filter.http.modsecurity.v2.RuleSet>}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getRuleSetsList = function() {
  return /** @type{!Array<!proto.envoy.config.filter.http.modsecurity.v2.RuleSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.envoy.config.filter.http.modsecurity.v2.RuleSet, 2));
};


/** @param {!Array<!proto.envoy.config.filter.http.modsecurity.v2.RuleSet>} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setRuleSetsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.addRuleSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.envoy.config.filter.http.modsecurity.v2.RuleSet, opt_index);
};


proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.clearRuleSetsList = function() {
  this.setRuleSetsList([]);
};


/**
 * optional string custom_intervention_message = 3;
 * @return {string}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getCustomInterventionMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setCustomInterventionMessage = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional AuditLogging audit_logging = 5;
 * @return {?proto.envoy.config.filter.http.modsecurity.v2.AuditLogging}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getAuditLogging = function() {
  return /** @type{?proto.envoy.config.filter.http.modsecurity.v2.AuditLogging} */ (
    jspb.Message.getWrapperField(this, proto.envoy.config.filter.http.modsecurity.v2.AuditLogging, 5));
};


/** @param {?proto.envoy.config.filter.http.modsecurity.v2.AuditLogging|undefined} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setAuditLogging = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.clearAuditLogging = function() {
  this.setAuditLogging(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.hasAuditLogging = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool request_headers_only = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getRequestHeadersOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setRequestHeadersOnly = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool response_headers_only = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getResponseHeadersOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setResponseHeadersOnly = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool regression_logs = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getRegressionLogs = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setRegressionLogs = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional envoy.config.filter.http.transformation_ee.v2.DlpTransformation dlp_transformation = 8;
 * @return {?proto.envoy.config.filter.http.transformation_ee.v2.DlpTransformation}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.getDlpTransformation = function() {
  return /** @type{?proto.envoy.config.filter.http.transformation_ee.v2.DlpTransformation} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation, 8));
};


/** @param {?proto.envoy.config.filter.http.transformation_ee.v2.DlpTransformation|undefined} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.setDlpTransformation = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.clearDlpTransformation = function() {
  this.setDlpTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurity.prototype.hasDlpTransformation = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.config.filter.http.modsecurity.v2.RuleSet.repeatedFields_, null);
};
goog.inherits(proto.envoy.config.filter.http.modsecurity.v2.RuleSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.config.filter.http.modsecurity.v2.RuleSet.displayName = 'proto.envoy.config.filter.http.modsecurity.v2.RuleSet';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.config.filter.http.modsecurity.v2.RuleSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    ruleStr: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filesList: jspb.Message.getRepeatedField(msg, 3),
    directory: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet}
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.config.filter.http.modsecurity.v2.RuleSet;
  return proto.envoy.config.filter.http.modsecurity.v2.RuleSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet}
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRuleStr(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addFiles(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirectory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.config.filter.http.modsecurity.v2.RuleSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRuleStr();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getDirectory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string rule_str = 1;
 * @return {string}
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.getRuleStr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.setRuleStr = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string files = 3;
 * @return {!Array<string>}
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.getFilesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.setFilesList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.addFiles = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.clearFilesList = function() {
  this.setFilesList([]);
};


/**
 * optional string directory = 4;
 * @return {string}
 */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.getDirectory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.envoy.config.filter.http.modsecurity.v2.RuleSet.prototype.setDirectory = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.repeatedFields_, null);
};
goog.inherits(proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.displayName = 'proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.toObject = function(includeInstance, msg) {
  var f, obj = {
    disabled: jspb.Message.getFieldWithDefault(msg, 1, false),
    ruleSetsList: jspb.Message.toObjectList(msg.getRuleSetsList(),
    proto.envoy.config.filter.http.modsecurity.v2.RuleSet.toObject, includeInstance),
    customInterventionMessage: jspb.Message.getFieldWithDefault(msg, 3, ""),
    auditLogging: (f = msg.getAuditLogging()) && proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.toObject(includeInstance, f),
    requestHeadersOnly: jspb.Message.getFieldWithDefault(msg, 6, false),
    responseHeadersOnly: jspb.Message.getFieldWithDefault(msg, 7, false),
    dlpTransformation: (f = msg.getDlpTransformation()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute;
  return proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 2:
      var value = new proto.envoy.config.filter.http.modsecurity.v2.RuleSet;
      reader.readMessage(value,proto.envoy.config.filter.http.modsecurity.v2.RuleSet.deserializeBinaryFromReader);
      msg.addRuleSets(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomInterventionMessage(value);
      break;
    case 5:
      var value = new proto.envoy.config.filter.http.modsecurity.v2.AuditLogging;
      reader.readMessage(value,proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.deserializeBinaryFromReader);
      msg.setAuditLogging(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestHeadersOnly(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResponseHeadersOnly(value);
      break;
    case 8:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation.deserializeBinaryFromReader);
      msg.setDlpTransformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getRuleSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.envoy.config.filter.http.modsecurity.v2.RuleSet.serializeBinaryToWriter
    );
  }
  f = message.getCustomInterventionMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAuditLogging();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.envoy.config.filter.http.modsecurity.v2.AuditLogging.serializeBinaryToWriter
    );
  }
  f = message.getRequestHeadersOnly();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getResponseHeadersOnly();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getDlpTransformation();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool disabled = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.setDisabled = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated RuleSet rule_sets = 2;
 * @return {!Array<!proto.envoy.config.filter.http.modsecurity.v2.RuleSet>}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.getRuleSetsList = function() {
  return /** @type{!Array<!proto.envoy.config.filter.http.modsecurity.v2.RuleSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.envoy.config.filter.http.modsecurity.v2.RuleSet, 2));
};


/** @param {!Array<!proto.envoy.config.filter.http.modsecurity.v2.RuleSet>} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.setRuleSetsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.envoy.config.filter.http.modsecurity.v2.RuleSet}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.addRuleSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.envoy.config.filter.http.modsecurity.v2.RuleSet, opt_index);
};


proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.clearRuleSetsList = function() {
  this.setRuleSetsList([]);
};


/**
 * optional string custom_intervention_message = 3;
 * @return {string}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.getCustomInterventionMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.setCustomInterventionMessage = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional AuditLogging audit_logging = 5;
 * @return {?proto.envoy.config.filter.http.modsecurity.v2.AuditLogging}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.getAuditLogging = function() {
  return /** @type{?proto.envoy.config.filter.http.modsecurity.v2.AuditLogging} */ (
    jspb.Message.getWrapperField(this, proto.envoy.config.filter.http.modsecurity.v2.AuditLogging, 5));
};


/** @param {?proto.envoy.config.filter.http.modsecurity.v2.AuditLogging|undefined} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.setAuditLogging = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.clearAuditLogging = function() {
  this.setAuditLogging(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.hasAuditLogging = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool request_headers_only = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.getRequestHeadersOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.setRequestHeadersOnly = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool response_headers_only = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.getResponseHeadersOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.setResponseHeadersOnly = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional envoy.config.filter.http.transformation_ee.v2.DlpTransformation dlp_transformation = 8;
 * @return {?proto.envoy.config.filter.http.transformation_ee.v2.DlpTransformation}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.getDlpTransformation = function() {
  return /** @type{?proto.envoy.config.filter.http.transformation_ee.v2.DlpTransformation} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_transformation_ee_transformation_pb.DlpTransformation, 8));
};


/** @param {?proto.envoy.config.filter.http.transformation_ee.v2.DlpTransformation|undefined} value */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.setDlpTransformation = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.clearDlpTransformation = function() {
  this.setDlpTransformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.config.filter.http.modsecurity.v2.ModSecurityPerRoute.prototype.hasDlpTransformation = function() {
  return jspb.Message.getField(this, 8) != null;
};


goog.object.extend(exports, proto.envoy.config.filter.http.modsecurity.v2);
